import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-referral-progress',
  templateUrl: './referral-progress.component.html',
  styleUrls: ['./referral-progress.component.scss']
})
export class ReferralProgressComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/alliance/referral-progress/referral-progress.component.ts